const plugin = require('tailwindcss/plugin')

const theme = {
	
	fontFamily: {
		display: ['Inter', 'sans-serif'],
		body: ['Inter', 'sans-serif'],
	},

  extend: {
    colors: {

      primary: {
        light: '#76c1ff',
        default: '#2e91fc',
				dark: '#0064c8',
				alpha: "hsl(211, 97%, 58%, 75%)"
      },

      secondary: {
        light: "#4f6c9c",
        default: "#1e416d",
				dark: "#001b42",
				alpha: "hsl(213, 57%, 27%, 75%)"
			},
			 
			dull: {
        light: '#f6f9fc',
        default: '#d7dde9',
        dark: '#4a5a83'
			},

			success: { 
        light: '#f1faf7',
				default: '#33c48d',
				dark: '#085640'
			},

			warning: {
        light: '#fdfdea',
				default: '#e3a007',
				dark: '#7b4721'
			}, 

			danger: {
        light: '#fdf1f2',
				default: '#f97f7f',
				dark: '#9e2726'
			}
			
    },

    minWidth: {
      1: "48px",
      2: "96px",
      3: "144px",
      4: "192px",
      5: "240px",
      6: "288px",
      7: "336px",
      8: "384px",
      9: "432px",
      10: "480px"
    },

    maxWidth: {
      1: "48px",
      2: "96px",
      3: "144px",
      4: "192px",
      5: "240px",
      6: "288px",
      7: "336px",
      8: "384px",
      9: "432px",
      10: "480px"
    }
	}
	
}

module.exports = {
  theme,
  // plugins: [ plugin(spacing) ]
}
